module.exports = __webpack_public_path__ + "media/2.f47eb18f.mp3";